import React from "react";

const Content = (props) => {
    return <React.Fragment>
        nd mẫu
    </React.Fragment>
}

export default Content;